import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent from "../../../../components/OB/TableComponent";
import KullanimSekliAPI from "../../../../apis/OB/Get/KullanimSekliAPI";
import InsaatSinifiAPI from "../../../../apis/OB/Get/InsaatSinifiAPI";
import InsaatMaliyetBedelleriAPI from "../../../../apis/OB/Get/InsaatMaliyetBedelleriAPI";

const InsaatMaliyetBedelleri: React.FC = () => {

    const columns = [
        { header: "Yılı", field: "yili", className: "text-center" },
        { header: "Kullanım Şekli", field: "kullanimSekliAdi", className: "text-center" },
        { header: "İnşaat Türü", field: "insaatTuruAdi", className: "text-center" },
        { header: "Kullanım Sınıfı", field: "kullanimSinifi", className: "text-center" },
        { header: "Maliyet Bedeli", field: "maliyetBedeli", className: "text-center" },
    ];
    const [data, setData] = useState<any[]>([]);
    const [kullanimSekliData, setKullanimSekliData] = useState<any[]>([]);
    const [insaatSinifiData, setInsaatSinifiData] = useState<any[]>([]);

    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { yilListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));
    const [selectedKullanimSekli, setSelectedKullanimSekli] = useState<any>();
    const [selectedInsaatSinifi, setSelectedInsaatSinifi] = useState<any>();

    const [isLoading, setisLoading] = useState<boolean>(false);

    //Kullanım Şekli Liste API
    useEffect(() => {
        KullanimSekliAPI.getKullanimSekliListe(undefined)
            .then((res) => {
                setKullanimSekliData(res.data);
            })
            .catch((err) => {
            });
    }, []);
    //İnşaat Sınıfı Liste API
    useEffect(() => {
        InsaatSinifiAPI.getInsaatSinifiListe(undefined)
            .then((res) => {
                setInsaatSinifiData(res.data);
            })
            .catch((err) => {
            });
    }, []);
    //InsaatMaaliyetBedelleriAPI 
    useEffect(() => {
        fetchData(false);
    }, [])

    const fetchData = async (isPass: boolean = true) => {
        if (selectedYear !== 0) {
            setisLoading(true);
            const response = await InsaatMaliyetBedelleriAPI.getInsaatMaaliyetBedelleriListe(
                selectedYear,
                selectedKullanimSekli,
                selectedInsaatSinifi
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)


        }
        else {
            setSearchControl(false)
            showToast("Lütfen Yılı Seçiniz", "error");
        }
    }

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));
        setSelectedInsaatSinifi(undefined)
        setSelectedKullanimSekli(undefined)

    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Yıl</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="yil"
                                        label="yil"
                                        error={selectedYear == undefined && searchControl == false ? true : false}

                                        value={selectedYear || ""}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value || undefined));
                                        }}                                >
                                        {yilListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.yili}                                            >
                                                {item.yili}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Kullanım Şekli</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        value={selectedKullanimSekli || ""}
                                        label="Kullanım Şekli"
                                        onChange={(e) => {
                                            setSelectedKullanimSekli(Number(e.target.value || undefined));
                                        }}
                                    >
                                        {kullanimSekliData.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.kullanimSekliKodu}                                            >
                                                {item.kullanimSekliAdi}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">İnşaat Sınıfı</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        value={selectedInsaatSinifi || ""}
                                        label="İnşaat Sınıfı"
                                        onChange={(e) => {
                                            setSelectedInsaatSinifi(Number(e.target.value || undefined));
                                        }}
                                    >
                                        {insaatSinifiData.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.insaatSinifiKodu}                                            >
                                                {item.insaatSinifiAdi}
                                            </MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent columns={columns} data={data} recordsPerPage={12}></TableComponent>
                }
            </div >
        </div >
    )
}

export default InsaatMaliyetBedelleri;